import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { sanitizeNoteHtml } from '../utils';

/**
 * Renders trusted backend HTML (e.g. claim notes) through `[innerHTML]` while
 * preserving its formatting — headings, bold, inline colors, dividers — which the
 * built-in Angular sanitizer would otherwise strip.
 *
 * The input is first passed through {@link sanitizeNoteHtml}, which uses DOMPurify
 * with a tag/attribute allowlist to remove XSS vectors (scripts, event handlers,
 * `javascript:` URIs, unknown elements), then marked safe.
 *
 * Usage: `<div [innerHTML]="htmlString | safeHtml"></div>`
 */
@Pipe({
  name: 'safeHtml',
})
export class SafeHtmlPipe implements PipeTransform {
  private readonly sanitizer = inject(DomSanitizer);

  transform(html: string | null | undefined): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(sanitizeNoteHtml(html ?? ''));
  }
}
